export default "__VITE_ASSET__SoZQOCsK__"